import { BrowserModule, Title } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { JwtModule } from '@auth0/angular-jwt';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from '../app/shared/shared.module';
import { MainModule } from './main/main.module';

import { environment } from '@environments/environment';

import { AuthModule } from './auth/auth.module';
import { UsersModule } from './users/users.module';
import { OrdersModule } from './orders/orders.module';

import {
  TranslateModule,
  TranslateLoader,
  MissingTranslationHandler
} from '@ngx-translate/core';
import { ApiTranslateLoader } from './shared/apiTranslationLoader';
import { ApiMissingTranslationHandler } from './shared/apiMissingTranslationHandler';
import { HttpClient, HttpClientModule } from '@angular/common/http';

import { appInitializerProviders } from './shared/appInitializerProviders';
import { resolverProviders } from './shared/resolvers';
import { httpInterceptorProviders } from './shared/http-interceptors';
import { ErrorComponent } from './error/error.component';
import { RepositoryModule } from './repository/repository.module';
import { FormContactModule } from './form-contact/form-contact.module';
import { AdvancedSearchModule } from './advanced-search/advanced-search.module';
import { MissionsModule } from './missions/missions.module';
import { TimeTrackingModule } from './time-tracking/time-tracking.module';
import { BillingModule } from './billing/billing.module';
import { ContactsModule } from './contacts/contacts.module';
import { RecurringOrdersModule } from './recurring-orders/recurring-orders.module';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { CustomMatPaginationService } from '@services/custom-mat-pagination.service';
import { MAT_TOOLTIP_DEFAULT_OPTIONS } from '@angular/material/tooltip';

export function tokenGetterFactory(): string {
  return localStorage.getItem(environment.tokenKey);
}

export function TranslateLoaderFactory(http: HttpClient): ApiTranslateLoader {
  return new ApiTranslateLoader(http);
}

@NgModule({
  declarations: [
    AppComponent,
    ErrorComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    SharedModule,
    AuthModule,
    MainModule,
    UsersModule,
    OrdersModule,
    MissionsModule,
    RepositoryModule,
    BillingModule,
    ContactsModule,
    FormContactModule,
    TimeTrackingModule,
    AdvancedSearchModule,
    RecurringOrdersModule,
    JwtModule.forRoot({
      config: {
        tokenGetter: tokenGetterFactory,
        allowedDomains: [environment.apiDomain],
        disallowedRoutes: [environment.identityApiUrl + 'connect/token']
      }
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: TranslateLoaderFactory,
        deps: [HttpClient]
      },
      missingTranslationHandler: {
        provide: MissingTranslationHandler,
        useClass: ApiMissingTranslationHandler
      }
    })
  ],
  providers: [
    appInitializerProviders,
    httpInterceptorProviders,
    resolverProviders,
    Title,
    {
      provide: MatPaginatorIntl,
      useClass: CustomMatPaginationService,
    },
    {
      provide: MAT_TOOLTIP_DEFAULT_OPTIONS,
      useValue: {
        showDelay: 0,
        hideDelay: 0,
        touchendHideDelay: 1500,
        position: 'below',
        disableTooltipInteractivity: true
      },
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
